export default __webpack_public_path__ + "static/media/marker.86e0b361.svg";